import { ReactNode } from 'react';
import {
  ActionIcon,
  createStyles,
  getSize,
  MantineTheme,
  rem,
  UnstyledButton,
} from '@mantine/core';
import { SwitchVertical } from 'tabler-icons-react';

const sizes = {
  xs: rem(30),
  sm: rem(36),
  md: rem(42),
  lg: rem(50),
  xl: rem(60),
};

// const markerSize = 10;
// const markerBorderSize = 2;
// const markerSpaceRight = 8;
// const markerPaddingRight = markerSize + markerSpaceRight;

// const trackSize = 1;

const useContainerStyles = createStyles(
  (theme, { radius }: { radius?: keyof MantineTheme['radius'] }, { size }) => {
    return {
      container: {
        position: 'relative',
        border: `${rem(1)} solid ${theme.colors.gray[4]}`,
        borderRadius: theme.fn.radius(radius),
        padding: `0 calc(${getSize({ size, sizes })}  / 3)`,
        // paddingLeft: `calc(${getSize({ size, sizes })}  / 3 + ${rem(
        //   markerPaddingRight
        // )})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      },
      buttonContainer: {
        flexGrow: 1,
      },
      button: {
        ...theme.fn.fontStyles(),
        flexGrow: 2,
        height: getSize({ size, sizes }),
        width: '100%',
        position: 'relative',
        borderBottom: `1px solid ${theme.colors.gray[4]}`,
        borderRadius: 0,
        lineHeight: `calc(${getSize({ size, sizes })} - ${rem(2)})`,
        color: theme.black,

        // '&:active': theme.activeStyles,

        ':hover': {
          borderBottomColor: theme.colors.gray[4],
        },

        // '::after': {
        //   content: '""',
        //   display: 'block',
        //   backgroundColor: 'white',

        //   width: rem(markerSize),
        //   height: rem(markerSize),
        //   transform: `translate(-${rem(markerPaddingRight)}, -50%)`,
        //   border: `${rem(markerBorderSize)} solid ${theme.fn.primaryColor()}`,

        //   position: 'absolute',
        //   top: '50%',
        //   borderRadius: '50%',
        // },
        // '::before': {
        //   // content: '""',
        //   display: 'block',

        //   position: 'absolute',
        //   top: `calc(50% + ${rem(markerSize / 2)})`,
        //   bottom: `calc(-50%)`,

        //   transform: `translateX(-${rem(
        //     markerPaddingRight - markerSize / 2 + trackSize
        //   )})`,
        //   border: `${rem(trackSize)} solid ${theme.fn.primaryColor()}`,
        //   borderColor: theme.colors.gray[4],
        // },
        // ':last-child::after': {},
        // ':last-child::before': {
        //   display: 'none',
        // },
        ':last-child': {
          borderBottom: 0,
        },
      },
      buttonPlaceholder: {
        ...theme.fn.placeholderStyles(),
      },
      switchButtonContainer: {
        flexShrink: 0,
        paddingLeft: `calc(${getSize({ size, sizes })}  / 3)`,
      },
      switchButton: {
        ':hover': {
          borderColor: theme.fn.primaryColor(),
        },
      },
    };
  }
);

type SelectStationsInputProps = {
  placeholder?: { start: ReactNode; end: ReactNode };
  value?: { start: string; end: string };
  onClickStart?: () => void;
  onClickEnd?: () => void;
  onSwitch?: () => void;
};

export const SelectStationsInput = ({
  value = { start: '', end: '' },
  placeholder = { start: '', end: '' },
  onClickStart,
  onClickEnd,
  onSwitch,
}: SelectStationsInputProps) => {
  const styles = useContainerStyles({ radius: 'sm' }, { size: 'lg', name: '' });

  return (
    <div className={styles.classes.container}>
      <div className={styles.classes.buttonContainer}>
        <UnstyledButton
          className={styles.classes.button}
          onClick={onClickStart}
        >
          {value.start ? (
            value.start
          ) : (
            <span className={styles.classes.buttonPlaceholder}>
              {placeholder?.start}
            </span>
          )}
        </UnstyledButton>

        <UnstyledButton className={styles.classes.button} onClick={onClickEnd}>
          {value.end ? (
            value.end
          ) : (
            <span className={styles.classes.buttonPlaceholder}>
              {placeholder?.end}
            </span>
          )}
        </UnstyledButton>
      </div>

      <div className={styles.classes.switchButtonContainer}>
        <ActionIcon
          radius="sm"
          className={styles.classes.switchButton}
          onClick={onSwitch}
        >
          <SwitchVertical size="1.125rem" />
        </ActionIcon>
      </div>
    </div>
  );
};
